/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const Info: React.FC<IconProps> = ({ size = 18, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 18 18"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1758 2.98923C9.74466 2.65353 8.25525 2.65353 6.82411 2.98923C4.9213 3.43556 3.43557 4.92129 2.98923 6.8241C2.65353 8.25525 2.65353 9.74466 2.98923 11.1758C3.43557 13.0786 4.9213 14.5643 6.82411 15.0107C8.25525 15.3464 9.74466 15.3464 11.1758 15.0107C13.0786 14.5643 14.5643 13.0786 15.0107 11.1758C15.3464 9.74466 15.3464 8.25525 15.0107 6.82411C14.5643 4.9213 13.0786 3.43556 11.1758 2.98923ZM6.60145 2.03999C8.17904 1.66994 9.82086 1.66994 11.3985 2.03999C13.6618 2.5709 15.429 4.33812 15.9599 6.60145C16.33 8.17904 16.33 9.82086 15.9599 11.3985C15.429 13.6618 13.6618 15.429 11.3985 15.9599C9.82086 16.33 8.17904 16.33 6.60145 15.9599C4.33812 15.429 2.5709 13.6618 2.03999 11.3985C1.66994 9.82087 1.66994 8.17904 2.03999 6.60144C2.5709 4.33812 4.33812 2.5709 6.60145 2.03999Z"
        fill="#FB8C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8.0625C9.31066 8.0625 9.5625 8.31434 9.5625 8.625V11.625C9.5625 11.9357 9.31066 12.1875 9 12.1875C8.68934 12.1875 8.4375 11.9357 8.4375 11.625V8.625C8.4375 8.31434 8.68934 8.0625 9 8.0625Z"
        fill="#FB8C00"
      />
      <circle
        cx="9"
        cy="6.75"
        r="0.5"
        fill="#FB8C00"
        stroke="#FB8C00"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Info
